/* eslint-disable */

import Colors from '../../Support/Theme/Colors/Colors';

/**
 * Create styles for `<UserMenu />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<UserMenu />` styles
 */
const userMenuStyles = ({ isLight, theme }) => ({
  branding: {
    left: 4,
    position: `relative`,
    top: 3,
  },
  customIcon: {
    height: theme.spacing(1) * 3,
    opacity: 0.54,
    width: theme.spacing(1) * 3,
  },
  logo: {
    maxHeight: theme.mixins.toolbar.minHeight,
    padding: theme.spacing(1),
  },
  menuWidth: {
    width: `100%`,
  },
  secondaryAction: {
    color: theme.palette.text.primary,
  },
  toolbar: {
    ...theme.mixins.toolbar,
  },
  userMenu: {},
  username: {
    display: `block`,
    fontWeight: 500,
  },
  placeOrderIcon: {
    position: `absolute`,
    top: 12,
    right: 16,
    height: theme.spacing(1) * 3,
    width: theme.spacing(1) * 3,
    color: Colors.boralgreen[500],
    '&> *': {
      position: `absolute`,
    },
  },
  addOrderIcon: {
    zIndex: 9999999,
  },
  leftNavEmail: {
    display: 'block',
  },
  appFeedback: {
    color: Colors.boralgreen[500],
  }
});

export default userMenuStyles;
